import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { SquareIconButton } from "mds/components/buttons/SquareIconButton";
import { RobotAIIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const AIPanelToggleButton: FC<{ isMobile?: boolean; isMenuItem?: boolean }> = ({
  isMobile = false,
  isMenuItem = false,
}) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.AIAssistant);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="AI Assistant - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText iconStart={<RobotAIIcon />} text={t("content_sidebar.title.AiAssistant")} />
      </MenuItem>
    );
  }

  return (
    <SquareIconButton
      eventName="AI Assistant - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="secondary"
      size={isMobile ? "l" : "m"}
      title={t("content_sidebar.title.AiAssistant")}
      onClick={togglePanel}
    >
      <RobotAIIcon />
    </SquareIconButton>
  );
};
